import React from "react"
import { Layout } from "../components/Layout/Layout"
import { SEO } from "../components/Seo/Seo"
import "../styles/akademik.css"

const AcademicPage = () => {
    const thesisSchema = {
        "@context": "https://schema.org",
        "@type": "ScholarlyArticle",
        "headline": "Analitik sosyoloji perspektifinden hesaplamalı sosyal bilim yöntemleri: Twitter verilerinin metin analizi ve network modellemesi",
        "alternativeHeadline": "Computational social science methods from an analytical sociology perspective: Text analysis and network modelling of Twitter data",
        "author": {
            "@type": "Person",
            "name": "Talip Akçelik"
        },
        "datePublished": "2023",
        "genre": "Academic Thesis",
        "about": ["Analitik Sosyoloji", "Hesaplamalı Sosyal Bilimler", "Twitter Analizi", "Network Modellemesi"],
        "provider": "YÖK Ulusal Tez Merkezi"
    };

    return (
        <Layout containerClass="academic-container">
            <SEO
                title="Akademik Çalışmalar | Analitik Sosyoloji ve Hesaplamalı Sosyal Bilimler"
                description="Talip Akçelik'in akademik çalışmaları: Analitik sosyoloji perspektifinden hesaplamalı sosyal bilim yöntemleri, Twitter veri analizi ve network modellemesi üzerine yüksek lisans tezi ve bildiriler."
            />
            <script type="application/ld+json">
                {JSON.stringify(thesisSchema)}
            </script>
            <div className="academic-page">
                <h1 className="academic-title">Akademik Çalışmalar</h1>

                <div className="academic-list">
                    <article className="academic-card">
                        <span className="academic-card__type">Yüksek Lisans Tezi</span>
                        <h2 className="academic-card__title-tr">
                            Analitik sosyoloji perspektifinden hesaplamalı sosyal bilim yöntemleri: Twitter verilerinin metin analizi ve network modellemesi
                        </h2>
                        <h3 className="academic-card__title-en">
                            Computational social science methods from an analytical sociology perspective: Text analysis and network modelling of Twitter data
                        </h3>

                        <div className="academic-card__meta">
                            <div className="academic-card__meta-item">
                                <b>Yıl:</b> 2023
                            </div>
                            <div className="academic-card__meta-item">
                                <b>Konu:</b> Sosyoloji = Sociology
                            </div>
                            <div className="academic-card__meta-item">
                                <b>Yazar:</b> Talip Akçelik
                            </div>
                        </div>

                        <div className="academic-card__footer">
                            <a
                                href="https://tez.yok.gov.tr/UlusalTezMerkezi/TezGoster?key=9MiDp3x86xrwjpi5-14w-V444llQYZZeW9g-_dyIlJJfUWQEdwINJvAPxfEfDyF6"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn--primary"
                            >
                                Tezi Görüntüle / İncele
                            </a>
                        </div>
                    </article>

                    <article className="academic-card">
                        <span className="academic-card__type">Bildiri Sunumu</span>
                        <h2 className="academic-card__title-tr">
                            Dijital Çağda Sosyal Araştırmanın Kesişim Noktaları: Büyük Veri, Hesaplamalı Sosyal Bilim Yöntemleri ve Analitik Sosyoloji
                        </h2>

                        <div className="academic-card__meta">
                            <div className="academic-card__meta-item">
                                <b>Kongre:</b> 3. Ulusal Sosyoloji Kongresi
                            </div>
                            <div className="academic-card__meta-item">
                                <b>Kurum:</b> Başkent Üniversitesi
                            </div>
                            <div className="academic-card__meta-item">
                                <b>Tarih:</b> 19 Aralık 2025
                            </div>
                        </div>

                        <div className="academic-card__reference" style={{ marginTop: '1rem', fontSize: '0.85rem', color: 'var(--hiq-color-gray-4)', borderLeft: '3px solid var(--hiq-color-gray-6)', paddingLeft: '1rem', fontStyle: 'italic', lineHeight: '1.4' }}>
                            Akçelik, T. (2025, 18-19 Aralık). Dijital Çağda Sosyal Araştırmanın Kesişim Noktaları: Büyük Veri, Hesaplamalı Sosyal Bilim Yöntemleri ve Analitik Sosyoloji [Bildiri Sunumu]. 3. Ulusal Sosyoloji Kongresi, Başkent Üniversitesi, Ankara.
                        </div>

                        <div className="academic-card__footer" style={{ marginTop: '1.5rem' }}>
                            <a
                                href="/kitapcik.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn--primary"
                            >
                                Bildiri Özetini / Kitapçığı Görüntüle
                            </a>
                        </div>
                    </article>

                </div>
            </div>
        </Layout>
    )
}

export default AcademicPage
